import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aceb0c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapsable-wapper" }
const _hoisted_2 = { class: "expand-wapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "筛选", -1))
const _hoisted_4 = { class: "form-wapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", {
        class: "right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeExpandState && _ctx.changeExpandState(...args)))
      }, _toDisplayString(_ctx.expandState ? "收起" : "展开"), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.expandState)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
        : _createCommentVNode("", true)
    ])
  ]))
}